import type { CorrectnessLevel } from '@dermloop/static-values';
import { IsDateString, IsOptional } from 'class-validator';

/**
 * DTO used for requesting a search in training assessments.
 */
export interface TrainingAssessmentsSearchDto {
  correctnessLevels?: CorrectnessLevel[];

  // Assessed date as range. If both null, all dates are implicitly selected
  assessedDateFrom?: Date;
  assessedDateTo?: Date;

  // Nullable string array. If no string specified, all are implicitly selected
  diagnosisIds?: string[];

  // If true, sorts assessed date as ascending
  sortAssessedDateAsc: boolean;

  // Number of assessments to take
  take?: number;

  // Number of assessments to skip
  skip?: number;
}

/**
 * DTO used for requesting a count of the current user's training assessments.
 * Both date bounds are optional; omitting them returns the total count.
 */
export class TrainingAssessmentsCountDto {
  @IsOptional()
  @IsDateString()
  afterDate?: string;

  @IsOptional()
  @IsDateString()
  beforeDate?: string;
}

/**
 * DTO returned by the training assessments count endpoint.
 */
export interface TrainingAssessmentsCountResultDto {
  count: number;
}

/**
 * DTO used for requesting training assessments statistics.
 */
export interface TrainingAssessmentsStatisticsDto {
  // Date range to calculate statistics within
  assessedDateFrom: Date;
  assessedDateTo: Date;
  // How many distributed dates to find within date range
  amountDistributedDates: number;
  // How many training assessments to do calculations on, for each distributed date
  amountTrainingAssessments: number;
}

/**
 * DTO used for returning training assessment statistics.
 */
export interface TrainingAssessmentsStatisticsResultDto {
  statistics: { date: Date; avgCorrect: number; avgMaxOffset: number }[];
}
